module.exports = __webpack_public_path__ + "static/img/bg.215c7f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg.jpg
// module id = 273
// module chunks = 153